export enum View {
	Inspirational = 'inspirational',
	Standard = 'standard',
	Overview = 'overview',
}
